export default __webpack_public_path__ + "static/media/QD.c20eb8d2.svg";